import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography } from "antd";
import * as XLSX from "xlsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import { orderHistory } from "../../../controllers/V1/promocodes/promocodeController";
import Loading from "../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import { formatProjectDate } from "../../../controllers/common";
import moment from "moment";
import { usePermissions } from "../../../controllers/PermissionContext";
const VendorListDeletePopUp = ({ popUpOpen, togglePopUp }) => {
  const PERMISSION = usePermissions("promoCodesOrder");
  const handleCancel = () => togglePopUp();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleExport = async (e) => {
    e.preventDefault(); // Prevent the default form submission

    setError(null); // Reset the error state before each request
    try {
      setIsLoading(true);
      const formData = new FormData(e.target);
      let from_date = formData.get('from_date');
      let to_date = formData.get('to_date');

      if (from_date && !to_date) {
        to_date = moment().format('YYYY-MM-DDTHH:mm');
      }
      const option = {
        isExport : true,
        sort: { createdAt : -1 },
        condition: {
          ...(formData.get("order_no")          && { order_no           : formData.get("order_no") }),
          ...(formData.get("buyer_first_name")  && { buyer_first_name   : { $regex: formData.get("buyer_first_name"), $options: "i", } }),
          ...(formData.get("buyer_last_name")   && { buyer_last_name    : { $regex: formData.get("buyer_last_name"), $options: "i", } }),
          ...(formData.get("buyer_mobile")      && { buyer_mobile       : { $regex: formData.get("buyer_mobile"), $options: "i", } }),
          ...(formData.get("buyer_area")        && { buyer_area       : { $regex: formData.get("buyer_area"), $options: "i", } }),
          ...(formData.get("cpr_number")      && { cpr_number       : { $regex: formData.get("cpr_number"), $options: "i", } }),

          ...(formData.get("seller_first_name") && { seller_first_name  : { $regex: formData.get("seller_first_name"), $options: "i", } }),
          ...(formData.get("seller_last_name")  && { seller_last_name   : { $regex: formData.get("seller_last_name"), $options: "i", } }),
          ...(formData.get("seller_mobile")     && { seller_mobile      : parseInt(formData.get("seller_mobile")) }),
          ...(formData.get("seller_pos_number") && { seller_pos_number  : parseInt(formData.get("seller_pos_number")) }),
          ...(formData.get("seller_store_name") && { seller_store_name  : { $regex: formData.get("seller_store_name"), $options: "i", } }),
          
          ...(formData.get("coupon_code")       && { coupon_code        : { $regex: formData.get("coupon_code"), $options: "i", } }),
          ...(formData.get("code")              && { code               : { $regex: formData.get("code"), $options: "i", } }),
          ...(formData.get("points")            && { points             : parseFloat(formData.get("points")) }),

          ...(formData.get("status")            && { status             : formData.get("status")} ),

          ...((from_date && to_date) && {
            createdAt: {
              $gte: moment(from_date).format('YYYY-MM-DD HH:mm:ss'),
              $lte: moment(to_date).format('YYYY-MM-DD HH:mm:ss'),
            },
          }),
        },
        select: {
          ...(formData.get("select_order_no") && { order_no: true }),
          ...(formData.get("select_buyer_first_name") && { buyer_first_name: true }),
          ...(formData.get("select_buyer_last_name") && { buyer_last_name: true }),
          ...(formData.get("select_buyer_mobile") && { buyer_mobile: true }),
          ...(formData.get("select_buyer_area") && { buyer_area: true }),
          ...(formData.get("select_cpr_number") && { cpr_number: true }),
          ...(formData.get("select_seller_first_name") && { seller_first_name: true }),
          ...(formData.get("select_seller_last_name") && { seller_last_name: true }),
          ...(formData.get("select_seller_mobile") && { seller_mobile: true }),
          ...(formData.get("select_seller_pos_number") && { seller_pos_number: true }),
          ...(formData.get("select_seller_store_name") && { seller_store_name: true }),
          ...(formData.get("select_coupon_code") && { coupon_code: true }),
          ...(formData.get("select_voucher_number") && { voucher_number: true }),
          ...(formData.get("select_code") && { code: true }),
          ...(formData.get("select_points") && { points: true }),
          // ...(formData.get("select_qty") && { qty: true }),
          // ...(formData.get("select_total_point") && { total_point: true }),
          ...(formData.get("select_status") && { status: true }),
          ...(formData.get("select_createdAt") && { createdAt: true }),
          ...(formData.get("select_draw_date") && { draw_date: true, draw_time: true }),
        },
      };

      // Make the API call
      const res = await orderHistory(option);
      if (res.status === true) {
        const { select } = option;
        let transformedData = [];
        if(res?.result?.length > 0){
          transformedData = await Promise.all(res.result.map((item) => {
            const drawDateTime =
              item?.draw_date && item.draw_date !== "N/A"
                ? moment(`${item.draw_date} ${item.draw_time || "00:00"}:00`).format("DD-MM-YYYY hh:mm A")
                : "N/A";
            const coupon = item?.coupon_code?.split(',');
            if (Array.isArray(coupon)) {
              let i=0;
              return coupon.map((coupon_no) => {
                let voucher_number = item?.voucher_number[i]?.voucher_number;
                i++;
                try {
                  // Transform voucher data here
                  return {
                    ...(
                      select?.order_no ||
                      select.buyer_first_name ||
                      select.buyer_last_name ||
                      select.buyer_mobile ||
                      select.buyer_area ||
                      select.cpr_number ||
                      // select.seller_first_name ||
                      // select.seller_last_name ||
                      select.seller_mobile ||
                      select.seller_pos_number ||
                      select.seller_store_name ||
                      select.code ||
                      select.coupon_code ||
                      select.voucher_number ||
                      select.points ||
                      select.status || 
                      select.createdAt ||
                      select.draw_date
                    ? {
                      ...(select?.order_no && {"Order No" : item.order_no}),
                      ...(select?.buyer_first_name && {"Buyer's First Name" : item.buyer_first_name}),
                      ...(select?.buyer_last_name && {"Buyer's Last Name" : item.buyer_last_name}),
                      ...(select?.buyer_mobile && {"Buyer's Mobile" : item.buyer_mobile}),
                      ...(select?.buyer_area && {"Buyer's Area" : item.buyer_area}),
                      ...(select?.cpr_number && {"CPR Number" : item.cpr_number}),
                      // ...(select?.seller_first_name && {"Seller's First Name" : item.seller_first_name}),
                      // ...(select?.seller_last_name && {"Seller's Last Name" : item.seller_last_name}),
                      // ...(select?.seller_mobile && {"Seller's Mobile" : item.seller_mobile}),
                      ...(select?.seller_pos_number && {
                          "Seller's POS Number" : item.seller_pos_number,
                          // "Seller's POS Serial No" : item?.seller_user_id?.pos_serial_id,
                        }),
                      ...(select?.seller_store_name && {
                        "Seller's Store Name" : item?.seller_store_name || 'N/A',
                        "Seller's Bind Person Name" : item?.seller_user_id?.bind_person_name || 'N/A',
                      }),
                      ...(select?.code && {"Category" : item.code}),
      
                      ...((select?.coupon_code && (PERMISSION?.fullAccess === 'Y' || PERMISSION?.coupon === 'Y')) && {"Raffle Code" : coupon_no}),
                      ...((select?.voucher_number && (PERMISSION?.fullAccess === 'Y' || PERMISSION?.voucher === 'Y')) && {"Promo Code" : voucher_number}),
      
                      ...(select?.points && {"Points" : item.points}),
                     
                      ...(select?.status && {"Status" : item.status}),
                      ...(select?.createdAt && {"Order Date" : moment(formatProjectDate(item.createdAt)).format('YYYY-MM-DD HH:mm')}),
                      ...(select?.draw_date && {"Draw Date & Time" : drawDateTime}),
                    }:{
                      "Order No" : item.order_no,
                      "Buyer's First Name" : item.buyer_first_name,
                      "Buyer's Last Name" : item.buyer_last_name,
                      "Buyer's Mobile" : item.buyer_mobile,
                      "Buyer's Area" : item?.buyer_area || 'N/A',
                      "CPR Number" : item?.cpr_number || 'N/A',
                      // "Seller's First Name" : item.seller_first_name,
                      // "Seller's Last Name" : item.seller_last_name,
                      // "Seller's Mobile" : item.seller_mobile,
                      "Seller's POS Number" : item.seller_pos_number,
                      "Seller's Store Name" : item?.seller_store_name || 'N/A',
                      "Seller's Bind Person Name" : item?.seller_user_id?.bind_person_name || 'N/A',
                      // "Seller's POS Serial No" : item?.seller_user_id?.pos_serial_id,
                      "Category" : item.code,
      
                      ...((PERMISSION?.fullAccess === 'Y' || PERMISSION?.coupon === 'Y') && {"Raffle Code" : coupon_no}),
                      ...((PERMISSION?.fullAccess === 'Y' || PERMISSION?.voucher === 'Y') && {"Promo Code" : voucher_number}),
      
                      "Points" : item.points,
                      
                      "Status" : item.status,
                      "Order Date" : moment(formatProjectDate(item.createdAt)).format('YYYY-MM-DD HH:mm'),
                      "Draw Date & Time" : drawDateTime,
                    })
                  };
                } catch (error) {
                  return [];
                }
              });
            } else{
              try {
                return {
                  ...(
                    select?.order_no ||
                    select.buyer_first_name ||
                    select.buyer_last_name ||
                    select.buyer_area ||
                    select.cpr_number ||
                    select.buyer_mobile ||
                    // select.seller_first_name ||
                    // select.seller_last_name ||
                    // select.seller_mobile ||
                    select.seller_pos_number ||
                    select.seller_store_name ||
                    select.code ||
                    select.coupon_code ||
                    select.voucher_number ||
                    select.points ||
                    select.status || 
                    select.createdAt ||
                    select.draw_date
                  ? {
                    ...(select?.order_no && {"Order No" : item.order_no}),
                    ...(select?.buyer_first_name && {"Buyer's First Name" : item.buyer_first_name}),
                    ...(select?.buyer_last_name && {"Buyer's Last Name" : item.buyer_last_name}),
                    ...(select?.buyer_mobile && {"Buyer's Mobile" : item.buyer_mobile}),
                    ...(select?.buyer_area && {"Buyer's Area" : item?.buyer_area || 'N/A'}),
                    ...(select?.cpr_number && {"CPR Number" : item?.cpr_number || 'N/A'}),
                    // ...(select?.seller_first_name && {"Seller's First Name" : item.seller_first_name}),
                    // ...(select?.seller_last_name && {"Seller's Last Name" : item.seller_last_name}),
                    // ...(select?.seller_mobile && {"Seller's Mobile" : item.seller_mobile}),
                    ...(select?.seller_pos_number && {
                        "Seller's POS Number" : item.seller_pos_number,
                        // "Seller's POS Serial No" : item?.seller_user_id?.pos_serial_id,
                      }),
                    ...(select?.seller_store_name && {"Seller's Store Name" : item?.seller_store_name || 'N/A'}),
                    ...(select?.code && {"Category" : item.code}),
    
                    ...((select?.coupon_code && (PERMISSION?.fullAccess === 'Y' || PERMISSION?.coupon === 'Y')) && {"Raffle Code" : item?.coupon_no}),
                    ...((select?.voucher_number && (PERMISSION?.fullAccess === 'Y' || PERMISSION?.voucher === 'Y')) && {"Promo Code" : item?.voucher_number[0]?.voucher_number}),
    
                    ...(select?.points && {"Points" : item.points}),
                   
                    ...(select?.status && {"Status" : item.status}),
                    ...(select?.createdAt && {"Order Date" : moment(formatProjectDate(item.createdAt)).format('YYYY-MM-DD HH:mm')}),
                    ...(select?.draw_date && {"Draw Date & Time" : drawDateTime}),
                  }:{
                    "Order No" : item.order_no,
                    "Buyer's First Name" : item.buyer_first_name,
                    "Buyer's Last Name" : item.buyer_last_name,
                    "Buyer's Mobile" : item.buyer_mobile,
                    "Buyer's Area" : item?.buyer_area || 'N/A',
                    "CPR Number" : item?.cpr_number || 'N/A',
                    // "Seller's First Name" : item.seller_first_name,
                    // "Seller's Last Name" : item.seller_last_name,
                    // "Seller's Mobile" : item.seller_mobile,
                    "Seller's POS Number" : item.seller_pos_number,
                    "Seller's Store Name" : item?.seller_store_name || 'N/A',
                    "Seller's Bind Person Name" : item?.seller_user_id?.bind_person_name || 'N/A',
                    // "Seller's POS Serial No" : item?.seller_user_id?.pos_serial_id,
                    "Category" : item.code,
    
                    ...((PERMISSION?.fullAccess === 'Y' || PERMISSION?.coupon === 'Y') && {"Raffle Code" : item?.coupon_no}),
                    // "Raffle Code" : item?.coupon_no,
                    // "Promo Code" : item?.voucher_number[0]?.voucher_number,
    
                    "Points" : item.points,
                    
                    "Status" : item.status,
                    "Order Date" : moment(formatProjectDate(item.createdAt)).format('YYYY-MM-DD HH:mm'),
                    "Draw Date & Time" : drawDateTime,
                  })
                };
              } catch (error) {
                return [];
              }
            } 
          }));
        }
        await exportToExcel(transformedData.flat()); 
        handleCancel(); 
      } else {
        setIsLoading(false);
        setError("No records found matching the criteria.");
      }
    } catch (error) {
      setIsLoading(false);
      setError("An error occurred while exporting the data.");
      console.error("Export Error:", error);
    }
  };

  const exportToExcel = async (data) => {
    try {
      const workbook = XLSX.utils.book_new();
      const worksheet1 = XLSX.utils.json_to_sheet(data);

      XLSX.utils.book_append_sheet(workbook, worksheet1, "Promo-Code-Orders");
      XLSX.writeFile(workbook, `Promo-Code-Orders_${moment().format('YYYY-MM-DD')}.xlsx`);
    } catch (error) {
      alert("Error generating Excel file: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const [checkedData, setCheckedData] = useState({});
    const handleChecked = (e) =>{
      try {
        const {name, value} = e.target;
        setCheckedData((prev)=>({
          ...prev,
          [name] : prev[name] === "Y" ? "N" : "Y",
        }))
      } catch (error) {
        
      }
    }

  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Typography
            variant="h5"
            component="div"
            gutterBottom
            className="inventory_popup_title_heading"
          >
            Export Order
          </Typography>
          <Link
            to={false}
            style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }}
            onClick={handleCancel}
          >
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>

        <Typography
          variant="body1"
          component="div"
          className="my_delete_popup_paragraph"
        >
          <div className="container-fluid">
            <div className="categories_open_popup_main_contnet">
              <form onSubmit={handleExport}>
                <div className="form-group row">
                  {/* Flat Fields */}
                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="order_no" className="all_lable_for_vendor_dashbaord" > Order Number: </label>
                    <input title="Order No." type="text" name="order_no" id="order_no" placeholder="Order Number" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="buyer_first_name" className="all_lable_for_vendor_dashbaord" > Buyer's First Name: </label>
                    <input  title="Buyer's First Name" type="text" name="buyer_first_name" id="buyer_first_name" placeholder="Buyer's First Name" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="buyer_last_name" className="all_lable_for_vendor_dashbaord" > Buyer's Last Name: </label>
                    <input  title="Buyer's Last Name" type="text" name="buyer_last_name" id="buyer_last_name" placeholder="Buyer's Last Name" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="buyer_mobile" className="all_lable_for_vendor_dashbaord" > Buyer's Mobile No. : </label>
                    <input  title="Buyer's Mobile" type="text" name="buyer_mobile" id="buyer_mobile" placeholder="Buyer's Mobile No." className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="buyer_area" className="all_lable_for_vendor_dashbaord" > Buyer's Area : </label>
                    <input  title="Buyer's Area" type="text" name="buyer_area" id="buyer_area" placeholder="Buyer's Area" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="cpr_number" className="all_lable_for_vendor_dashbaord" > CPR Number : </label>
                    <input title="CPR Number" type="text" name="cpr_number" id="cpr_number" placeholder="CPR Number" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="seller_first_name" className="all_lable_for_vendor_dashbaord" > Seller's First Name: </label>
                    <input type="text" name="seller_first_name" id="seller_first_name" placeholder="Seller's First Name" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="seller_last_name" className="all_lable_for_vendor_dashbaord" > Seller's Last Name: </label>
                    <input type="text" name="seller_last_name" id="seller_last_name" placeholder="Seller's Last Name" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="seller_mobile" className="all_lable_for_vendor_dashbaord" > Seller's Mobile No.: </label>
                    <input type="text" name="seller_mobile" id="seller_mobile" placeholder="Seller's Mobile No." className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="seller_pos_number" className="all_lable_for_vendor_dashbaord" > Seller's POS No.: </label>
                    <input type="text" name="seller_pos_number" id="seller_pos_number" placeholder="Seller's POS No." className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="seller_store_name" className="all_lable_for_vendor_dashbaord" > Seller's Store Name: </label>
                    <input type="text" name="seller_store_name" id="seller_store_name" placeholder="Seller's Store Name" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="coupon_code" className="all_lable_for_vendor_dashbaord" > Coupon Code : </label>
                    <input type="text" name="coupon_code" id="coupon_code" placeholder="Coupon Code" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="code" className="all_lable_for_vendor_dashbaord" > Promo Code: </label>
                    <input type="text" name="code" id="code" placeholder="Code" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="points" className="all_lable_for_vendor_dashbaord" > Points : </label>
                    <input type="number" name="points" id="points" placeholder="Points" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label htmlFor="status" className="all_lable_for_vendor_dashbaord" > Order's Status : </label>
                    <select name="status" id="status" className="form-control categories_select_tg_enter_product">
                      <option value='Active' selected >Active</option>
                      <option value='Cancel' >Cancel</option>
                      <option value=''>All</option>
                    </select>
                  </div>


                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label for="select_name" className="all_lable_for_vendor_dashbaord" > Date specific (If any) : </label>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="from_date" className="all_lable_for_vendor_dashbaord">From :</label>
                    <input type="datetime-local" name="from_date" id="from_date" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="to_date" className="all_lable_for_vendor_dashbaord">To :</label>
                    <input type="datetime-local" name="to_date" id="to_date" className="form-control categories_select_tg_enter_product" />
                  </div>

                  {/* Nested Fields */}
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label className="all_lable_for_vendor_dashbaord">
                      Select Fields to Export:
                    </label>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label htmlFor="select_order_no" className="all_lable_for_vendor_dashbaord">
                      <input type="checkbox" name="select_order_no" id="select_order_no" className="form-check-input" 
                      checked={checkedData?.select_order_no !== "Y" ? true : false} onClick={handleChecked} /> Order No. </label>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label htmlFor="select_buyer_first_name" className="all_lable_for_vendor_dashbaord">
                      <input type="checkbox" name="select_buyer_first_name" id="select_buyer_first_name" className="form-check-input" 
                      checked={checkedData?.select_order_no !== "Y" ? true : false} onClick={handleChecked} /> Buyer's first name </label>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label htmlFor="select_buyer_last_name" className="all_lable_for_vendor_dashbaord">
                      <input type="checkbox" name="select_buyer_last_name" id="select_buyer_last_name" className="form-check-input"
                      checked={checkedData?.select_order_no !== "Y" ? true : false} onClick={handleChecked} /> Buyer's last name </label>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label htmlFor="select_buyer_mobile" className="all_lable_for_vendor_dashbaord">
                      <input type="checkbox" name="select_buyer_mobile" id="select_buyer_mobile" className="form-check-input"
                      checked={checkedData?.select_order_no !== "Y" ? true : false} onClick={handleChecked} /> Buyer's mobile no. </label>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label htmlFor="select_buyer_area" className="all_lable_for_vendor_dashbaord">
                      <input type="checkbox" name="select_buyer_area" id="select_buyer_area" className="form-check-input"
                      checked={checkedData?.select_buyer_area !== "Y" ? true : false} onClick={handleChecked} /> Buyer's area </label>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label htmlFor="select_cpr_number" className="all_lable_for_vendor_dashbaord">
                      <input type="checkbox" name="select_cpr_number" id="select_cpr_number" className="form-check-input"
                      checked={checkedData?.select_cpr_number !== "Y" ? true : false} onClick={handleChecked} /> CPR Number </label>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label htmlFor="select_seller_first_name" className="all_lable_for_vendor_dashbaord">
                      <input type="checkbox" name="select_seller_first_name" id="select_seller_first_name" className="form-check-input"
                      checked={checkedData?.select_seller_first_name !== "Y" ? true : false} onClick={handleChecked} /> Seller's first name </label>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label htmlFor="select_seller_last_name" className="all_lable_for_vendor_dashbaord">
                      <input type="checkbox" name="select_seller_last_name" id="select_seller_last_name" className="form-check-input"
                      checked={checkedData?.select_seller_last_name !== "Y" ? true : false} onClick={handleChecked} /> Seller's last name </label>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label htmlFor="select_seller_mobile" className="all_lable_for_vendor_dashbaord">
                      <input type="checkbox" name="select_seller_mobile" id="select_seller_mobile" className="form-check-input"
                      checked={checkedData?.select_seller_mobile !== "Y" ? true : false} onClick={handleChecked} /> Seller's mobile no. </label>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label htmlFor="select_seller_pos_number" className="all_lable_for_vendor_dashbaord">
                      <input type="checkbox" name="select_seller_pos_number" id="select_seller_pos_number" className="form-check-input"
                      checked={checkedData?.select_seller_pos_number !== "Y" ? true : false} onClick={handleChecked} /> Seller's POS no. </label>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label htmlFor="select_seller_store_name" className="all_lable_for_vendor_dashbaord">
                      <input type="checkbox" name="select_seller_store_name" id="select_seller_store_name" className="form-check-input"
                      checked={checkedData?.select_seller_store_name !== "Y" ? true : false} onClick={handleChecked} /> Seller's store name </label>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label htmlFor="select_coupon_code" className="all_lable_for_vendor_dashbaord">
                      <input type="checkbox" name="select_coupon_code" id="select_coupon_code" className="form-check-input"
                      checked={checkedData?.select_coupon_code !== "Y" ? true : false} onClick={handleChecked} /> Coupon Code </label>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label htmlFor="select_voucher_number" className="all_lable_for_vendor_dashbaord">
                      <input type="checkbox" name="select_voucher_number" id="select_voucher_number" className="form-check-input"
                      checked={checkedData?.select_voucher_number !== "Y" ? true : false} onClick={handleChecked} /> Voucher Number </label>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label htmlFor="select_code" className="all_lable_for_vendor_dashbaord">
                      <input type="checkbox" name="select_code" id="select_code" className="form-check-input"
                      checked={checkedData?.select_code !== "Y" ? true : false} onClick={handleChecked} /> Promo Code </label>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label htmlFor="select_points" className="all_lable_for_vendor_dashbaord">
                      <input type="checkbox" name="select_points" id="select_points" className="form-check-input"
                      checked={checkedData?.select_points !== "Y" ? true : false} onClick={handleChecked} /> Points </label>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label htmlFor="select_status" className="all_lable_for_vendor_dashbaord">
                      <input type="checkbox" name="select_status" id="select_status" className="form-check-input"
                      checked={checkedData?.select_status !== "Y" ? true : false} onClick={handleChecked} /> Order Status </label>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label htmlFor="select_createdAt" className="all_lable_for_vendor_dashbaord">
                      <input type="checkbox" name="select_createdAt" id="select_createdAt" className="form-check-input"
                      checked={checkedData?.select_createdAt !== "Y" ? true : false} onClick={handleChecked} /> Order Date </label>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label htmlFor="select_draw_date" className="all_lable_for_vendor_dashbaord">
                      <input type="checkbox" name="select_draw_date" id="select_draw_date" className="form-check-input"
                      checked={checkedData?.select_draw_date !== "Y" ? true : false} onClick={handleChecked} /> Draw Date & Time </label>
                  </div>

                  {/* Action Buttons */}
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="inventory_open_popup_action_btn">
                      <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel} > Cancel </button>
                      <button type="submit" className="btn btn-danger" disabled={isLoading} > Download Excel </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Typography>
        {error && <div style={{ color: "red" }}>{error}</div>}
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default VendorListDeletePopUp;
